import CheckIcon from "@mui/icons-material/Check";
import DraftsIcon from "@mui/icons-material/Drafts";
import WatchLaterIcon from "@mui/icons-material/WatchLater";

export const CaseStatus = {
  NEW: "serviceCases.status.new",
  IN_PROGRESS: "serviceCases.status.pending",
  CLOSED: "serviceCases.status.closed",
} as const;

export enum CreateCaseSource {
  LIST_PAGE = "listPage",
  DETAILS_PAGE = "detailsPage",
}

export const CaseIcon = {
  NEW: DraftsIcon,
  IN_PROGRESS: WatchLaterIcon,
  CLOSED: CheckIcon,
} as const;

export type CaseStatusKeys = keyof typeof CaseStatus;

export interface CaseDataObject {
  code: string;
  sfCaseNumber: string;
  status: CaseStatusKeys;
  completeData: boolean;
  reasonOfRequest: string;
  createdAt: string;
  updatedAt: string;
}
